import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const endpoints = {
  // Auth
  login: '/api/login',

  // Tours
  tours: '/api/tours',
  tour: (id: string) => `/api/tours/${id}`,
  tourTranslations: (id: string) => `/api/tours/${id}/translations`,
  tourStats: (id: string) => `/api/tours/${id}/stats`,
  tourStatsAggregate: '/api/tour-stats',
  groupStats: '/api/group-stats',
  aiSettings: '/api/ai-settings',
  aiStopChat: (tourId: string, stopId: string) => `/api/ai/tours/${tourId}/stops/${stopId}/chat`,

  // Tour Stops
  tourStops: (tourId: string) => `/api/tours/${tourId}/stops`,
  tourStop: (tourId: string, stopId: string) => `/api/tours/${tourId}/stops/${stopId}`,

  // Devices
  devices: '/api/devices',
  device: (macAddress: string) => `/api/devices/${macAddress}`,
  appInstallations: '/api/app-installations',
  appInstallationsBulk: '/api/app-installations/bulk-update',
  appInstallation: (installationId: string) => `/api/app-installations/${encodeURIComponent(installationId)}`,

  // Audio Files
  audioFiles: '/api/audio-files',
  audioFile: (id: string) => `/api/audio-files/${id}`,

  // Video Files
  videoFiles: '/api/video-files',
  videoFile: (id: string) => `/api/video-files/${id}`,

  // Map Fragment Images
  mapFragmentImages: '/api/map-fragment-images',
  mapFragmentImage: (id: string) => `/api/map-fragment-images/${id}`,

  // Virtual Worlds
  virtualWorlds: '/api/virtual-worlds',
  virtualWorld: (id: string) => `/api/virtual-worlds/${id}`,
};
